/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_RelationshipInputs */

const th_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสัมพันธ์ของคุณ`)
};

const en_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your relationship to them`)
};

const ja_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたとの関係`)
};

const zh_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你与他的关系`)
};

const es_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu relación con él o ella`)
};

const pt_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua relação com ele`)
};

const id_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungan Anda dengannya`)
};

const fr_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre lien avec lui`)
};

const tl_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang ugnayan mo sa kanya`)
};

const vi_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quan hệ của bạn với họ`)
};

const ko_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 선수와의 관계`)
};

const de_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Verhältnis zu ihm`)
};

const ru_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кем вы ему приходитесь`)
};

const tr_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onunla ilişkiniz`)
};

const it_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo rapporto con lui`)
};

const pl_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoja relacja z nim`)
};

const uk_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ким ви йому доводитеся`)
};

const hi_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उनसे आपका संबंध`)
};

const ar_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صلتك به`)
};

const ms_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungan anda dengannya`)
};

const bn_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তাঁর সঙ্গে আপনার সম্পর্ক`)
};

const zh_tw2_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你與他的關係`)
};

const zh_hk2_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你與他的關係`)
};

const ur_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ان سے آپ کا رشتہ`)
};

const fa_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسبت شما با او`)
};

const sw_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhusiano wako naye`)
};

const nl_player_relationship = /** @type {(inputs: Player_RelationshipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw band met hem`)
};

/**
* | output |
* | --- |
* | "Your relationship to them" |
*
* @param {Player_RelationshipInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_relationship = /** @type {((inputs?: Player_RelationshipInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_RelationshipInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_relationship(inputs)
	if (locale === "ja") return ja_player_relationship(inputs)
	if (locale === "zh") return zh_player_relationship(inputs)
	if (locale === "es") return es_player_relationship(inputs)
	if (locale === "pt") return pt_player_relationship(inputs)
	if (locale === "id") return id_player_relationship(inputs)
	if (locale === "fr") return fr_player_relationship(inputs)
	if (locale === "tl") return tl_player_relationship(inputs)
	if (locale === "vi") return vi_player_relationship(inputs)
	if (locale === "ko") return ko_player_relationship(inputs)
	if (locale === "de") return de_player_relationship(inputs)
	if (locale === "ru") return ru_player_relationship(inputs)
	if (locale === "tr") return tr_player_relationship(inputs)
	if (locale === "it") return it_player_relationship(inputs)
	if (locale === "pl") return pl_player_relationship(inputs)
	if (locale === "uk") return uk_player_relationship(inputs)
	if (locale === "hi") return hi_player_relationship(inputs)
	if (locale === "ar") return ar_player_relationship(inputs)
	if (locale === "ms") return ms_player_relationship(inputs)
	if (locale === "bn") return bn_player_relationship(inputs)
	if (locale === "zh-TW") return zh_tw2_player_relationship(inputs)
	if (locale === "zh-HK") return zh_hk2_player_relationship(inputs)
	if (locale === "ur") return ur_player_relationship(inputs)
	if (locale === "fa") return fa_player_relationship(inputs)
	if (locale === "sw") return sw_player_relationship(inputs)
	if (locale === "nl") return nl_player_relationship(inputs)
	return en_player_relationship(inputs)
});